import React from 'react';

import { Box } from '@mui/material';

import { StepThreeFormValue } from '../../../../CreateUpdateOffer/components/schema';
import { Method } from '../../../ProductForm';
import ShippingAvailability from '../../Shipping';
import { FormValue, StepOneFormValue, StepTwoFormValue } from '../../schema';

type Values = StepOneFormValue & StepTwoFormValue & StepThreeFormValue;

type Props = {
  method?: Method;
  initialValues?: Values;
  values: Values;
  handlePersistFormDataStep?: (values: Partial<FormValue>) => void;
};

export const Form3: React.FC<Props> = ({ values, handlePersistFormDataStep }) => {
  React.useEffect(() => {
    if (handlePersistFormDataStep) handlePersistFormDataStep({ ...(values as FormValue) });
  }, [values]);

  return (
    <Box>
      <ShippingAvailability values={values} />
    </Box>
  );
};
